export default "__VITE_ASSET__BfzjzjP1__"